import { j as r } from "./jsx-runtime-944c88e2.js";
import { B as x } from "./cleave-react-node-c4a374e5.js";
import { a as B, u as D, i as j, g as t } from "./useAccount-2367dbfe.js";
import "react";
import { a as k, g as v, e as A, d as u } from "./domains-8f7837df.js";
import "./features-325864e1.js";
import { D as Z, q as oo } from "./eMyAsurionProvider-0702cfa3.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/react";
import "@tanstack/react-query";
import "@chakra-ui/icons";
import "./providers-fe718bdb.js";
import "@emotion/react";
import "./lodash-9598aa3c.js";
import "@emotion/styled";
import "react-router-dom";
import "./myasurion-shared.carrier.es.js";
import "framer-motion";
import "@react-oauth/google";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.utils.es.js";
import "./myasurion-shared.colors.es.js";
import "./ProfileIcon-8cf21b72.js";
import "./myasurion-shared.profile.es.js";
import "react-dom";
const Q = ({
  headerComponent: h,
  bypass: e = !1,
  env: n,
  children: f
}) => {
  var m, c, d, l;
  const [w] = B({ profileId: "", userId: "" }), [y] = D({ authorization: "", token: "", id: "" }), i = k(), a = v(), s = A(), p = j(w, y);
  if (!e) {
    if (!p)
      if (console.log(`Unauthorized user redirecting to ${t("/login")}`), i === "shared") {
        const o = sessionStorage.getItem("p"), g = u(
          a,
          o === "device_protection" || o === "repair" || o === "shared" ? o : "device_protection",
          (c = (m = n ?? s) == null ? void 0 : m.toString()) == null ? void 0 : c.toLowerCase(),
          !0
        );
        window.location.href = g ? g + "/login?logoutRedirect=true" : t("/login?logoutRedirect=true");
      } else
        window.location.href = t("login");
    !window.location.pathname.startsWith("/login") && i !== "shared" && window.location.origin === u(
      a,
      i,
      (l = (d = n ?? s) == null ? void 0 : d.toString()) == null ? void 0 : l.toLowerCase(),
      !0
    ) && (window.location.href = t("login"));
  }
  return /* @__PURE__ */ r.jsx(r.Fragment, { children: (e || p) && /* @__PURE__ */ r.jsxs(x, { id: "myasurion-protected-layout", children: [
    h,
    f
  ] }) });
};
export {
  Z as DesktopView,
  oo as MobileView,
  Q as ProtectedLayout
};
